import styled from 'styled-components'

import ContentBox from '../../components/ContentBox'
import ActionButton from '../../components/ActionButton'

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const ContentBoxC = styled(ContentBox)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const BackButton = styled(ActionButton)`
  margin-top: 70px;
`
